import { keyBy } from 'lodash';

import {
  SET_DATABASE_CALL_LIST,
  SET_DATABASE_CALL_LISTS,
  START_ADD_TO_CALL_LIST,
  STOP_ADD_TO_CALL_LIST
} from '../actions/call_lists';

export default function(state = {}, action) {
  switch (action.type) {
  case SET_DATABASE_CALL_LIST: {
    const { ...callLists } = state.callLists;
    callLists[action.callList.id] = action.callList;
    return { ...state, callLists };
  }
  case SET_DATABASE_CALL_LISTS: {
    const callLists = keyBy(action.callLists, list => list.id);
    return { ...state, callLists };
  }
  case START_ADD_TO_CALL_LIST: {
    return {
      ...state,
      contactIds: action.contactIds,
      isAddingContactsToList: true,
      targetListId: action.listId
    };
  }
  case STOP_ADD_TO_CALL_LIST: {
    return {
      ...state,
      contactIds: null,
      isAddingContactsToList: false,
      targetListId: null
    };
  }
  default:
    return state;
  }
}
